<script>
import Dropdown from '@/components/atoms/Dropdown.vue'
import InputCheckbox from '@/components/atoms/inputlib/components/InputCheckbox.vue'
import { mapGetters } from 'vuex'

export default {
    components: { Dropdown, InputCheckbox },
    props: {
        value: Array,
        categories: Array,
    },
    data() {
        return {
            currentStateOfValue: [],
        }
    },
    computed: {
        ...mapGetters(['smDevice']),

        filterOptions() {
            const items = [
                {
                    key: 'vegetarian',
                    count: 0,
                },
                {
                    key: 'vegan',
                    count: 0,
                },
                {
                    key: 'no_gluten',
                    count: 0,
                },
                {
                    key: 'nut_free',
                    count: 0,
                },
                {
                    key: 'dairy_free',
                    count: 0,
                },
                {
                    key: 'halal',
                    count: 0,
                },
                {
                    key: 'pescatarian',
                    count: 0,
                },
            ]
            for (let category of this.categories) {
                for (let meal of category.meals) {
                    for (let suitable of meal.suitable_for) {
                        const existIndex = items.findIndex((x) => x.key === suitable)
                        if (existIndex > -1) {
                            items[existIndex].count++
                        }
                    }
                }
            }

            return items.sort((a, b) => (a.key > b.key ? 1 : -1))
        },
    },
    watch: {
        currentStateOfValue() {
            if (!this.smDevice) {
                this.$emit('input', this.currentStateOfValue)
            }
        },
    },
    methods: {
        removeFilter(item) {
            const index = this.currentStateOfValue.indexOf(item)
            this.currentStateOfValue.splice(index, 1)
            this.$emit('input', this.currentStateOfValue)
        },
        apply() {
            this.$emit('input', this.currentStateOfValue)
            this.$nextTick(this.$refs.dropdown.close)
        },
        clearAll() {
            this.currentStateOfValue = []
            this.apply()
        },
        resetState() {
            this.currentStateOfValue = [...this.value]
        },
    },
}
</script>

<template lang="pug">
.menu-filter.d-flex.align-items-center
  .diets.selected-filters
    .diet.mr-3.mb-3(v-for="(filter, filterIndex) in currentStateOfValue" :key="filter" @click="removeFilter(filter)")
      span {{ $t(`diet.${filter}_short`) }}
      icon(icon="fa-solid fa-xmark" size="xs")
  .d-flex.align-items-start
    dropdown(ref="dropdown" right :xs="smDevice" @open="resetState" @close="resetState")
      .d-flex.align-items-center
        icon(icon="fa-solid fa-filter").mr-3
        span {{ $t('labels.filters') }}
      template(v-slot:content)
        .d-flex.h-100.flex-column
          .flex-grow-1.overflow-auto
            .btn.btn-list-item(v-for="(item, filterOptionIndex) in filterOptions" :class="{'disabled' : item.count === 0}")
              input-checkbox.menu-filter-checkbox.p-3.py-2.w-100(block :data="item.key" :disabled="item.count === 0" v-model="currentStateOfValue")
                .d-flex.align-items-center
                  span.mr-2
                    .diets.mr-3.ml-1
                      .diet {{ $t(`diet.${item.key}_short`) }}
                    span {{ $t(`diet.${item.key}`) }}
                  span.text-b2.text-sm ({{ item.count }})
          .pb-2.d-flex(v-if="smDevice")
            .btn.btn-secondary.btn-block.mr-3(@click="clearAll") Clear all
            .btn.btn-primary.btn-block.mt-0(@click="apply") Apply
</template>
